module.exports = __webpack_public_path__ + "static/img/logo_50.c86654a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_50.png
// module id = rmyV
// module chunks = 1